import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import useMedia from 'react-use/lib/useMedia'
import { getScreenSizes } from '@pretamanger/component-library'
import { LoadingOverlay } from '#src/common/components/loading-overlay'
import Translation from '#src/common/components/translation'
import { Categories } from '#src/products/components/categories'
import PageWithSideNav from '#src/page/components/layout/page-with-side-nav'
import FlyOut from '#src/products/components/fly-out'
import { SideNavContainer, SubMenuTitle, CategoriesContainer } from './styles'
import { category } from '#proptypes/index'
import { BoxAllergens } from '../filter-allergens'

const SideNav = ({
  categories,
  selectedIndex,
  openModal,
  useFilterAllergensFlag
}) => {
  const [showFlyout, setShowFlyout] = useState(false)
  const screenSizeMatched = useMedia(
    `(max-width: ${getScreenSizes().lg - 1}px)`
  )
  const titleText = <Translation id='product.listing.title' />
  const title = (
    <SubMenuTitle level='h2' styleOverride='headingBodyLg'>
      {titleText}
    </SubMenuTitle>
  )
  const additionalMenu = useFilterAllergensFlag ? (
    <BoxAllergens openModal={openModal} />
  ) : (
    <></>
  )

  useEffect(() => {
    if (screenSizeMatched !== showFlyout) {
      setShowFlyout(screenSizeMatched)
    }
    // todo surely showFlyout should be in the deps?
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [screenSizeMatched])

  return showFlyout ? (
    <FlyOut titleText={title} trigger={title} additionalMenu={additionalMenu}>
      <Categories categories={categories} selectedIndex={selectedIndex} />
    </FlyOut>
  ) : (
    <>
      {additionalMenu}
      {title}
      <CategoriesContainer>
        <Categories categories={categories} selectedIndex={selectedIndex} />
      </CategoriesContainer>
    </>
  )
}

SideNav.propTypes = {
  categories: PropTypes.arrayOf(category),
  selectedIndex: PropTypes.number
}

const WithSideNav = ({
  children,
  heading,
  categories,
  selectedCategoryIndex,
  isTransactional,
  isContentLoading,
  openModal,
  useFilterAllergensFlag
}) => {
  return (
    <LoadingOverlay loading={isContentLoading}>
      <PageWithSideNav
        className='gap-4 mt-0 lg:gap-0 lg:mt-8'
        heading={heading}
        sideNav={
          <SideNavContainer>
            <SideNav
              categories={categories}
              selectedIndex={selectedCategoryIndex}
              openModal={openModal}
              useFilterAllergensFlag={useFilterAllergensFlag}
            />
          </SideNavContainer>
        }
        isStickyMobileNav={isTransactional}
      >
        {children}
      </PageWithSideNav>
    </LoadingOverlay>
  )
}

WithSideNav.defaultProps = {
  selectedCategoryIndex: 0,
  isTransactional: false,
  isContentLoading: false
}

WithSideNav.propTypes = {
  children: PropTypes.node,
  heading: PropTypes.node,
  categories: PropTypes.arrayOf(category),
  selectedCategoryIndex: PropTypes.number,
  isTransactional: PropTypes.bool,
  isContentLoading: PropTypes.bool,
  openModal: PropTypes.func
}

export default WithSideNav
